import { connect } from 'react-redux';
import { createSelector } from 'reselect';
import AccessRequests from './component';

const selector = createSelector([], () => ({}));

export default connect(selector)(AccessRequests);
